import { render } from "./LessonLimitReached.vue?vue&type=template&id=0e6eae58&scoped=true"
import script from "./LessonLimitReached.vue?vue&type=script&lang=js"
export * from "./LessonLimitReached.vue?vue&type=script&lang=js"

import "./LessonLimitReached.vue?vue&type=style&index=0&id=0e6eae58&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e6eae58"]])

export default __exports__